import * as React from "react";
import classnames from "classnames";
import { Skeleton } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
/* empty css               */
const defaultSkeletonImage = (props) => /* @__PURE__ */ React.createElement("svg", { ...props, fill: "none", xmlns: "http://www.w3.org/2000/svg", height: "280" }, /* @__PURE__ */ React.createElement("rect", { width: "100%", height: "30", rx: "5", fill: "currentColor", y: "10" }), /* @__PURE__ */ React.createElement("rect", { width: "40%", height: "50", rx: "5", fill: "currentColor", y: "60" }), /* @__PURE__ */ React.createElement("rect", { width: "100%", height: "60", rx: "5", fill: "currentColor", y: "120" }), /* @__PURE__ */ React.createElement("rect", { width: "60%", height: "30", rx: "5", fill: "currentColor", y: "190" }), /* @__PURE__ */ React.createElement("rect", { width: "100%", height: "40", rx: "5", fill: "currentColor", y: "230" }));
const StoreTile = ({
  className,
  children,
  loading,
  SkeletonImage: CustomSkeletonImage,
  variant = "default",
  ...rest
}) => {
  const { getLabel } = useIntl();
  const SkeletonImage = defaultSkeletonImage ?? CustomSkeletonImage;
  return /* @__PURE__ */ React.createElement(
    "article",
    {
      ...rest,
      className: classnames("store-tile", className, {
        "store-tile--variant-bordered": variant === "bordered",
        "store-tile--variant-ghosted": variant === "ghosted"
      })
    },
    loading ? /* @__PURE__ */ React.createElement("div", { className: "store-tile__skeleton-loader" }, /* @__PURE__ */ React.createElement(Skeleton, { height: "100%", width: "100%" }, /* @__PURE__ */ React.createElement(SkeletonImage, { "aria-label": getLabel("common.loadingText") }))) : children
  );
};
export {
  StoreTile as default
};
//# sourceMappingURL=StoreTile.js.map
